import api from './api.ts';

export type InvestmentCategory =
  | 'crypto'
  | 'offshore'
  | 'stocks'
  | 'fixed_income'
  | 'funds'
  | 'other';

export type InvestmentStatus = 'active' | 'sold';

export interface Investment {
  id: string;
  description: string;
  category: InvestmentCategory;
  investedValue: number;
  currentValue: number;
  yieldAmount: number;
  yieldPercent: number;
  status: InvestmentStatus;
  currency?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface InvestmentPayload {
  description: string;
  category: InvestmentCategory;
  investedValue: number;
  currentValue?: number;
  status?: InvestmentStatus;
  currency?: string;
}

const basePath = '/investments';

export const InvestmentsAPI = {
  async list(): Promise<Investment[]> {
    const { data } = await api.get(basePath);
    return data;
  },

  async get(id: string): Promise<Investment> {
    const { data } = await api.get(`${basePath}/${id}`);
    return data;
  },

  async create(payload: InvestmentPayload): Promise<Investment> {
    const { data } = await api.post(basePath, payload);
    return data;
  },

  async update(id: string, payload: InvestmentPayload): Promise<Investment> {
    const { data } = await api.put(`${basePath}/${id}`, payload);
    return data;
  },

  async remove(id: string): Promise<void> {
    await api.delete(`${basePath}/${id}`);
  },
};

export default InvestmentsAPI;
